import './copy_text_input.less';

import noop from 'lodash/noop';
import React, { Component } from 'react';
import classNames from 'classnames';

import CopyToClipboardButton from 'zoomforth_component_lib/copy_to_clipboard_button.jsx';


class CopyTextInput extends Component {

  constructor(props) {
    super(props);

    this.handleRef = this.handleRef.bind(this);
  }

  componentDidMount() {
    if (this.props.focus) {
      this.inputRef.select();
    }
  }

  render() {
    const {
      button,
      buttonContent,
      buttonType,
      className,
      style,
      inputStyle,
      value,
      tellRef
    } = this.props;

    return ( 
      <div className="copy-text-input-container" style={style}>
        <input 
          className={classNames('copy-text-input', className)}
          type="text"
          readOnly={true} 
          style={{ cursor:'pointer', ...inputStyle }}
          value={value || ''}
          ref={(ref)=> { 
            tellRef(ref); // Callback to report ref to parent
            this.handleRef(ref); 
          }} 
          onFocus={()=> {
            this.inputRef.select();
          }}
        />

        {
          button &&
            <CopyToClipboardButton
              className="copy-button"
              data={value}
              type={buttonType}
            >
              { buttonContent }
            </CopyToClipboardButton>
        }
      </div>
    );
  }

  handleRef(ref) {
    this.inputRef = ref;
  }


}

CopyTextInput.defaultProps = {
  button: true,
  buttonContent: 'Copy',
  focus: false,
  tellRef: noop
};

export default CopyTextInput;
